import React from "react";
import { 
    Grid, GridItem, ClipboardCopy, Content, Tooltip
} from '@patternfly/react-core';
import { Icons } from 'shared/components/Icons/index'

const RequiredSoftware = ({
  userProfile
}) => {
  const virt_viewer_rh_install = `yum install virt-viewer`
  const virt_viewer_db_install = `apt install virt-viewer`
  const virt_viewer = <Content component="a" target="_blank" href="https://zspwyrzysk.pl/soft/inf.02/virt-viewer-x64-11.0-1.0.msi"><small>virt-viewer</small></Content>
  const virt_viewer_win_install = `msiexec /i virt-viewer-x64-11.0-1.0.msi`
  return (
    <>
    {/* Wymagane oprogramowanie */}
    <Grid
      hasGutter
      span={12}
        style={{
            fontSize: "13px",
            lineHeight: "1.6"
        }}
    >
      <GridItem>
        <Content component="h6">Wymagane oprogramowanie</Content>
        <table className="table">
          <tbody>
            <tr>
              <th>OS</th>
              <th>Oprogramowanie</th>
              <th>Dystrybucja</th>
              <th style={{ textAlign: "right" }}>Polecenie instalacji</th>
            </tr>
            {/* WIN */}
            <tr>
              <td>
                <Tooltip content={<div>Windows</div>}>
                  {Icons.Windows}
                </Tooltip>
              </td>
              <td>{virt_viewer}</td>
              <td>Windows 10, 11</td>
              <td className="small">
                <ClipboardCopy
                  copyAriaLabel="Copy inline compact example"
                  hoverTip="Kopiuj"
                  clickTip="Skopiowano"
                  variant="inline-compact"
                >
                  {virt_viewer_win_install}
                </ClipboardCopy>
              </td>
            </tr>
            {/* LINUX */}
            <tr>
              <td rowSpan={2}>
                <Tooltip content={<div>Linux</div>}>
                  {Icons.Linux}
                </Tooltip>
              </td>
              <td rowSpan={2}>virt-viewer</td>
              <td>Ubuntu / Debian</td>
              <td className="small">
                <ClipboardCopy
                  copyAriaLabel="Copy inline compact example"
                  hoverTip="Kopiuj"
                  clickTip="Skopiowano"
                  variant="inline-compact"
                >
                  {virt_viewer_db_install}
                </ClipboardCopy>
              </td>
            </tr>
            <tr>
              <td>Fedora / Red Hat</td>
              <td className="small">
                <ClipboardCopy
                  copyAriaLabel="Copy inline compact example"
                  hoverTip="Kopiuj"
                  clickTip="Skopiowano"
                  variant="inline-compact"
                >
                  {virt_viewer_rh_install}
                </ClipboardCopy>
              </td>
            </tr>
          </tbody>
        </table>
      </GridItem>
    </Grid>
    </>
  );
};

export default RequiredSoftware;